import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass/styled-components';
import { X } from 'lucide-react';

import { Notes } from 'components/organisms/contactDetail/components/notes';

export const NotesDrawerContent = ({ contact, onClose }) => (
  <Flex flexDirection="column" flexGrow="1" width="100%">
    <Flex
      as="header"
      alignItems="center"
      justifyContent="space-between"
      height="40px"
      px="4px"
      sx={{ borderBottom: '1px solid', borderColor: 'border.subtle' }}
    >
      <Flex
        data-testid="close-button"
        alignItems="center"
        justifyContent="center"
        width="40px"
        height="40px"
        color="neutral.400"
        sx={{ cursor: 'pointer' }}
        onClick={onClose}
      >
        <Box as={X} width="16px" height="16px" aria-hidden="true" />
      </Flex>
    </Flex>

    <Box p="16px">
      <Notes items={contact.notes} contactId={contact.id} type="public" />
    </Box>
  </Flex>
);

NotesDrawerContent.propTypes = {
  contact: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
};
